let override = {
    minHours: 0,
    maxHours: 23,
    openTimePicker: function () {
    var calendar = this;
    var $el = calendar.$el,
        app = calendar.app,
        is12HoursFormat = calendar.is12HoursFormat;
    if (!$el || !$el.length) return;
    $el.append('<div class="calendar-time-picker"></div>');
    var hoursArr = [];
    var minutesArr = [];
    var hoursMin = is12HoursFormat ? 1 : override.minHours;
    var hoursMax = is12HoursFormat ? 12 : override.maxHours;

    for (var i = hoursMin; i <= hoursMax; i += 1) {
        hoursArr.push(i);
    }

    // for (var _i2 = 0; _i2 <= 59; _i2 += 1) {
    minutesArr.push(0);
    minutesArr.push(15);
    minutesArr.push(30);
    minutesArr.push(45);
    // }

    var value;

    if (calendar.value && calendar.value.length) {
        value = [calendar.value[0].getHours(), calendar.value[0].getMinutes()];
    } else {
        value = [new Date().getHours(), new Date().getMinutes()];
    }

    if (is12HoursFormat) {
        value.push(value[0] < 12 ? 'AM' : 'PM');
        if (value[0] > 12) value[0] -= 12;
        if (value[0] === 0) value[0] = 12;
    }

    calendar.timePickerInstance = app.picker.create({
        containerEl: $el.find('.calendar-time-picker'),
        // openIn: 'popover',
        value: value,
        toolbar: true,
        rotateEffect: false,
        toolbarCloseText: calendar.params.toolbarCloseText,
        cols: [{
            values: hoursArr
        }, {
            divider: true,
            content: ':'
        }, {
            values: minutesArr,
            displayValues: minutesArr.map(function (m) {
                return m < 10 ? "0" + m : m;
            })
        }].concat(is12HoursFormat ? [{
            values: ['AM', 'PM']
        }] : [])
    });
        // calendar.timePickerInstance.open();
    calendar.timePickerInstance.$el.find('.toolbar a').removeClass('sheet-close popover-close').addClass('calendar-time-picker-close');
}
}
export {override};